enum MenuOptionLabel {
  None = 'none',
  PricePayment = 'Payment & Price',
  MakeModel = 'Make & Model',
  BodyType = 'Body Type'
}

export default MenuOptionLabel;
